import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-under-maintinance',
  templateUrl: './under-maintinance.component.html',
  styleUrls: ['./under-maintinance.component.scss']
})
export class UnderMaintinanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
